import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {CallJs} from "../../lib/types"

import {
	FileWidget as PublicFileWidget,
	FilesFoldersWidget as PublicFilesFoldersWidget
} from '../../memory/component/Public';

import {
	FileWidget as AdminFileWidget,
	FolderWidget as AdminFolderWidget,
	FilesFoldersWidget as AdminFilesFoldersWidget
} from '../../memory/component/Admin';

import {
	AdminMemoryParams,
	MemoryFile,
	MemoryFolder,
	FolderHierarchy,
	SelectCallbackMaybe,
	DeleteCallbackMaybe,
	MemoryParams
} from "../../memory/component/Types";

export interface AdminSpareFieldMemoryWidgetCallJsProps {
	fieldName: string
	memoryParams: AdminMemoryParams
	file: MemoryFile
}

export const adminSpareFieldMemoryWidgetCallJs: CallJs<AdminSpareFieldMemoryWidgetCallJsProps> = (replace, params) => {
	var node = document.createElement('div')
	replace(node)

	renderAdminFile(
		params.fieldName,
		params.memoryParams,
		params.file,
		node,
		'Link a File'
	)
}

//noinspection JSUnusedGlobalSymbols
export var renderAdminFilesFolders = (fieldName:string, memoryParams:AdminMemoryParams, files:MemoryFile[], folders:FolderHierarchy[], parentNode:Element) => {
	ReactDOM.render(
		<AdminFilesFoldersWidget
			fieldName={fieldName}
			memoryParams={memoryParams}
			files={files}
			folders={folders} />,
		parentNode
	);
};

//noinspection JSUnusedGlobalSymbols
export var renderAdminFile = (fieldName:string, memoryParams:AdminMemoryParams, file:MemoryFile, parentNode:Element, buttonLabel?:string, selectedCallback?:SelectCallbackMaybe, deleteCallback?:DeleteCallbackMaybe) => {
	ReactDOM.render(
		<AdminFileWidget
			fieldName={fieldName}
			memoryParams={memoryParams}
			selected={file}
			buttonLabel={buttonLabel}
			selectedCallback={selectedCallback}
			deleteCallback={deleteCallback} />,
		parentNode
	);
};

export var renderAdminFolder = (fieldName:string, memoryParams:AdminMemoryParams, folder:MemoryFolder|undefined, parentNode:Element, buttonLabel?:string, selectedCallback?:SelectCallbackMaybe, deleteCallback?:DeleteCallbackMaybe) => {
	ReactDOM.render(
		<AdminFolderWidget
			fieldName={fieldName}
			memoryParams={memoryParams}
			selected={folder}
			buttonLabel={buttonLabel}
			selectedCallback={selectedCallback}
			deleteCallback={deleteCallback} />,
		parentNode
	);
};

//noinspection JSUnusedGlobalSymbols
export var renderPublicFile = (memoryParams:MemoryParams, file:MemoryFile, parentNode:Element) => {
	ReactDOM.render(
		<PublicFileWidget memoryParams={memoryParams} file={file} />,
		parentNode
	);
};

//noinspection JSUnusedGlobalSymbols
export var renderPublicFilesFolders = (memoryParams:MemoryParams, files:MemoryFile[], folders:FolderHierarchy[], parentNode:Element) => {
	ReactDOM.render(
		<PublicFilesFoldersWidget
			memoryParams={memoryParams}
			files={files}
			folders={folders} />,
		parentNode
	);
};



// WEBPACK FOOTER //
// ./src/components/spare fields/MemoryFileWidget.tsx